import { filterConfig } from '@/helper/filterHelper';

interface OperatorModel {
  id: number;
  name: string;
  imgSrc: string;
  job: string;
  detailJob: string;
  rarity: number;
  initialCost: number;
  block: number;
  recruitCost: number;
  onlyCnVer: boolean;
  addedTiming: string;
  role: string;
  tags: string[];
  isGroupingTarget: boolean;
  sortOrder: number;
  visible: boolean;
};

const unchoicedOperator: OperatorModel = {
  id: 0,
  name: '',
  imgSrc: 'img/unchoiced_Icon.jpg',
  job: '',
  detailJob: '',
  rarity: 0,
  initialCost: 0,
  block: 0,
  recruitCost: 0,
  onlyCnVer: false,
  addedTiming: '',
  role: '',
  tags: [],
  isGroupingTarget: false,
  sortOrder: 0,
  visible: true,
};

type OperatorProperty = keyof OperatorModel;

const jobs = ['前衛', '狙撃', '重装', '医療', '補助', '術師', '特殊', '先鋒'];

const detailJobs = [
  '勇士', '強襲者', '術戦士', '領主', '闘士', '教官', '武者', '剣豪', '鎌撃士', '解放者', '重剣手',
  '速射手', '榴弾射手', '散弾射手', '精密射手', '戦術射手', '破城射手', '投擲手',
  '重盾衛士', '庇護衛士', '術技衛士', '破壊者', '決闘者', '堅城砲手', '哨戒衛士',
  '医師', '群癒師', '療養師', '放浪医', '呪癒師', '鎖癒師',
  '緩速師', '吟遊者', '召喚師', '呪詛師', '祈祷師', '工匠',
  '中堅術師', '拡散術師', '爆撃術師', '法陣術師', '操機術師', '連鎖術師', '秘術師',
  '執行者', '推撃手', '鉤縄師', '潜伏者', '鬼才', '行商人', '罠師', '傀儡師',
  '先駆兵', '突撃兵', '旗手', '戦術家', "偵察兵"
]

interface OperatorFilterConfigs {
  targetProperty: OperatorProperty;
  filterConfigs: filterConfig[];
}

export { OperatorModel, unchoicedOperator, OperatorProperty, jobs, detailJobs, OperatorFilterConfigs };
